<template>
<div class="chapter">
<div class="inner_page">
<p class="linespace"> </p>
<p class="linespace"> </p>
<p class="dedication"><a id="page_v"></a><em>DEDICATION</em></p>
<p class="image"><img alt="Image" src="images/star.jpg"/></p>
<p class="linespace"> </p>
<p class="para"> </p>
<p class="para">It is humbling to write this dedication. For General George Washington and the “gallant few”——the 2,500 men——who crossed the Delaware River with him on the night of December 25—26, 1776, facing impossible odds, and by so doing, saved a nation.</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// dedication.vue?669e99fa